import api from '@/api';

import { API_BASE_URL } from '..';
import { Profile } from '../Profiles/Profiles.types';
import { Role } from './Roles.types';

const CONTROLLER_URL = `${API_BASE_URL}/roles`;

export async function getAllRoles() {
  const result = (await api.get(`${CONTROLLER_URL}`, null)) as unknown;

  return result as Role[];
}

export async function getRolesByProfileId(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Profile;
}
